// Localized species content (description, note, colour, uses) for ES & ZH.
const WORKABILITY = {
  es: { Excellent: "Excelente", Good: "Buena" },
  zh: { Excellent: "优秀", Good: "良好" },
};

const TR = {
  "white-oak": {
    es: {
      note: "Denso, de grano cerrado y apreciado para tonelería, pisos y carpintería marina. Nuestra calidad de exportación más solicitada.",
      description:
        "El Roble Blanco es el hardwood norteamericano de referencia: denso, duradero y de grano cerrado, con un duramen relleno de tílides que lo hace naturalmente estanco y apto para barricas de vino y uso exterior. Sus largos radios medulares producen una figura más pronunciada que la del roble rojo, y ensayos estructurales confirman mayor resistencia de fibra que el roble europeo. Con excelente capacidad de curvado al vapor y un acabado soberbio, es la especie elegida para tonelería, construcción marina y pisos premium en los mercados europeos y asiáticos.",
      color: "Marrón claro a medio",
      uses: ["Tonelería", "Pisos", "Carpintería marina", "Ebanistería", "Chapa rebanada"],
    },
    zh: {
      note: "致密、闭孔纹理，是制桶、地板和船用细木工的首选。我们最受欢迎的出口等级。",
      description:
        "白橡木是北美硬木的标杆——致密、耐用、纹理紧密，心材充满侵填体，天然防水，适合制作酒桶和户外使用。其髓射线比红橡木更长，木纹更为突出；欧洲结构测试证实其纤维强度高于欧洲橡木。白橡木蒸汽弯曲性能出色、易于涂饰，是制桶、船舶建造和高端地板的首选树种，在欧洲和亚洲市场需求强劲。",
      color: "浅棕至中棕色",
      uses: ["制桶", "地板", "船用细木工", "橱柜", "刨切单板"],
    },
  },
  "black-walnut": {
    es: {
      note: "Duramen chocolate intenso, excepcional para muebles finos y carpintería arquitectónica.",
      description:
        "El Nogal Negro Americano es una de las maderas para muebles más codiciadas del mundo: su duramen marrón claro a chocolate oscuro contrasta con una albura cremosa, a veces con llamativa figura ondulada o rizada muy buscada por los diseñadores. Considerado uno de los hardwoods americanos más resistentes a la pudrición, se trabaja fácilmente a mano o a máquina y admite un pulido excelente. Se ofrece vaporizado para uniformar el color o sin vaporizar para máximo contraste; es un clásico del mueble de alta gama, las culatas y los interiores arquitectónicos.",
      color: "Duramen marrón chocolate",
      uses: ["Muebles finos", "Culatas", "Carpintería arquitectónica", "Chapa"],
    },
    zh: {
      note: "浓郁的巧克力色心材，是高级家具和建筑木制品的极佳之选。",
      description:
        "美国黑胡桃是世界上最受追捧的家具用材之一，浅棕至深巧克力色的心材与奶白色边材形成鲜明对比，偶有设计师钟爱的波浪或卷曲花纹。它是美国最耐腐的硬木之一，手工和机械加工均十分容易，可抛光出极佳表面。可提供蒸汽处理（颜色均匀）或未蒸汽处理（对比最大化）两种规格，是高端家具、枪托和建筑室内装饰的经典用材。",
      color: "巧克力棕色心材",
      uses: ["高级家具", "枪托", "建筑木制品", "单板"],
    },
  },
  "hard-maple": {
    es: {
      note: "Clara, uniforme y excepcionalmente dura. La referencia para pisos y superficies deportivas.",
      description:
        "También llamado Arce de Azúcar, el Arce Duro es mundialmente famoso por su delicado color cremoso, su textura fina y cerrada y su extraordinaria resistencia a la abrasión y al desgaste. Pueden aparecer figuras muy apreciadas como 'curly', 'fiddleback' y 'ojo de pájaro', y la selección blanca (NHLA '1&2 white') ofrece el color más consistente disponible. Se mecaniza, tornea y acaba maravillosamente, siendo el estándar para boleras, pisos deportivos, tablas de carnicero, encimeras y pisos de alto tránsito.",
      color: "Blanco cremoso a pálido",
      uses: ["Pisos", "Superficies deportivas", "Tabla de carnicero", "Ebanistería"],
    },
    zh: {
      note: "色泽明亮、均匀且异常坚硬，是地板和运动场地的标杆用材。",
      description:
        "硬枫（又名糖枫）以其细腻的奶白色泽、紧密的纹理和出色的耐磨性享誉世界。可出现备受推崇的卷纹、琴背纹和鸟眼纹；白色精选级（NHLA '1&2 white'）可提供最稳定一致的颜色。硬枫的机加工、车削和涂饰性能俱佳，是保龄球道、运动地板、砧板、台面和高人流地板的标准用材。",
      color: "奶白至浅色",
      uses: ["地板", "运动场地", "砧板", "橱柜"],
    },
  },
  "western-red-cedar": {
    es: {
      note: "Naturalmente resistente a la pudrición, aromático y dimensionalmente estable para revestimientos y estructuras exteriores.",
      description:
        "El Cedro Rojo Occidental es un ícono canadiense: ligero, aromático y naturalmente resistente a la pudrición y a los insectos. Su estabilidad dimensional y su rico color lo convierten en la primera opción para revestimientos exteriores, terrazas, pérgolas y saunas en cualquier clima.",
      color: "Marrón rojizo",
      uses: ["Revestimiento y fachadas", "Terrazas", "Estructuras exteriores", "Carpintería"],
    },
    zh: {
      note: "天然防腐、芳香且尺寸稳定，适用于外墙板和户外结构。",
      description:
        "西部红雪松是加拿大的标志性树种——轻质、芳香，天然抗腐防虫。其尺寸稳定性和浓郁色泽使其成为各种气候下外墙挂板、露台、凉棚和桑拿房的首选用材。",
      color: "红棕色",
      uses: ["外墙挂板", "露台地板", "户外结构", "细木工"],
    },
  },
  "red-oak": {
    es: {
      note: "El caballo de batalla de los hardwoods americanos: grano abierto, fuerte y especificado en todo el mundo.",
      description:
        "El Roble Rojo es la especie dominante de los bosques de frondosas de EE. UU.: se necesita poco más de un segundo de crecimiento forestal para reponer un metro cúbico de madera aserrada. De grano recto y textura gruesa con la característica figura de radios medulares, ofrece muy buena resistencia en relación a su peso, alta resistencia a la compresión y excelente curvado al vapor. Duro, estable en seco y fácil de teñir y acabar, se especifica globalmente para muebles, pisos, molduras y carpintería interior con suministro constante y excelente valor.",
      color: "Rosado a marrón rojizo",
      uses: ["Muebles", "Pisos", "Molduras", "Puertas y carpintería"],
    },
    zh: {
      note: "美国硬木中的主力树种——开放纹理、强度高，在全球广泛使用。",
      description:
        "红橡木是美国硬木林中蓄积量最大的树种——森林每生长一秒多即可补充一立方米锯材。纹理通直、质地较粗，带有独特的髓射线花纹；其强度重量比优异，抗压强度高，蒸汽弯曲性能出色。红橡木坚硬、干燥后稳定、易于着色和涂饰，以稳定的供应和出色的性价比在全球广泛用于家具、地板、线条和室内细木工。",
      color: "粉红至红棕色",
      uses: ["家具", "地板", "线条", "门与细木工"],
    },
  },
  "american-cherry": {
    es: {
      note: "Cálidos tonos rojizos que se intensifican con el tiempo: favorita para ebanistería fina.",
      description:
        "El Cerezo Negro Americano es un hardwood supremo de EE. UU., único de Norteamérica, con un duramen rojo intenso a marrón rojizo que se oscurece bellamente con la luz. Su grano fino, uniforme y recto y su textura suave se tiñen y pulen hasta lograr una superficie excepcional; las tablas pueden suministrarse seleccionadas por color (p. ej. especificaciones 90/50 de duramen). Cultivado principalmente en Pensilvania, Nueva York, Virginia y Virginia Occidental, es muy apreciado para muebles finos, ebanistería, carpintería interior y paneles.",
      color: "Marrón rojizo cálido",
      uses: ["Muebles finos", "Ebanistería", "Molduras", "Paneles"],
    },
    zh: {
      note: "温暖的红色调随时间愈发深邃——高级橱柜的挚爱之选。",
      description:
        "美国黑樱桃是美国顶级硬木，北美独有，心材呈浓郁的红色至红棕色，随光照时间推移愈显温润。其纹理细腻、均匀、通直，质地光滑，着色与抛光效果卓越；板材可按颜色分选供应（如90/50心材规格）。主产于宾夕法尼亚、纽约、弗吉尼亚和西弗吉尼亚州，是高级家具、橱柜、室内细木工和护墙板的珍贵用材。",
      color: "温暖的红棕色",
      uses: ["高级家具", "橱柜", "线条", "护墙板"],
    },
  },
  "white-ash": {
    es: {
      note: "Tenaz, resistente al impacto y elástica: la madera de los mangos de herramientas y el equipamiento deportivo.",
      description:
        "El Fresno Americano combina una relación resistencia-peso excepcional con excelente resistencia al impacto, razón por la cual siempre ha sido la madera de los bates de béisbol, los palos de hockey y los mangos de herramientas. Su fuerte contraste entre el crecimiento blando de verano y el duro de invierno hace que no haya dos tablas iguales, y su magnífico curvado al vapor lo convierte en favorito de los fabricantes de muebles. Duro, estable en seco y fácil de acabar, luce igual de bien en muebles de tonos claros, pisos y arquitectura interior.",
      color: "Pálido, marrón claro",
      uses: ["Mangos de herramientas", "Equipamiento deportivo", "Pisos", "Muebles"],
    },
    zh: {
      note: "坚韧、抗冲击且富有弹性——工具手柄和运动器材的经典用材。",
      description:
        "美国白蜡木兼具出色的强度重量比和卓越的抗冲击性能，因此一直是棒球棒、曲棍球杆和工具手柄的传统用材。其夏材与冬材的强烈纹理对比使每块板材都独一无二；蒸汽弯曲性能极佳，深受家具制造商喜爱。白蜡木坚硬、干燥后稳定、易于涂饰，同样适用于浅色调家具、地板和室内建筑装饰。",
      color: "浅淡的浅棕色",
      uses: ["工具手柄", "运动器材", "地板", "家具"],
    },
  },
  "yellow-poplar": {
    es: {
      note: "Estable, de textura fina y fácil de pintar: un hardwood industrial versátil.",
      description:
        "El Álamo Amarillo — conocido en los mercados de exportación como Tulipwood Americano — es uno de los hardwoods de EE. UU. más prolíficos y exclusivo de Norteamérica. Posee una resistencia extraordinaria en relación a su peso, lo que lo hace cada vez más popular para usos estructurales como vigas laminadas y madera contralaminada (CLT), incluidos proyectos emblemáticos como el pabellón The Smile de Londres. De grano recto, textura fina y extremadamente estable en seco, se mecaniza limpiamente, acepta la pintura excepcionalmente bien y se ofrece en tablas más anchas y largas que la mayoría de las especies.",
      color: "Amarillo pálido a oliva",
      uses: ["Molduras", "Estructuras de gabinetes", "Carpintería para pintar", "Glulam y CLT", "Alma de contrachapado"],
    },
    zh: {
      note: "稳定、纹理细腻、易于涂漆——用途广泛的工业硬木。",
      description:
        "黄杨木（出口市场称美国鹅掌楸/Tulipwood）是美国蓄积量最大的硬木之一，北美独有。其强度重量比极为出色，越来越多地用于胶合梁和正交胶合木（CLT）等结构用途，包括伦敦地标项目 The Smile 展亭。纹理通直、质地细腻、干燥后极为稳定，机加工利落、涂漆性能出众，且板材宽度和长度均优于多数树种。",
      color: "淡黄至橄榄色",
      uses: ["线条", "柜体框架", "涂漆级细木工", "胶合木与CLT", "胶合板芯材"],
    },
  },
  "douglas-fir": {
    es: {
      note: "Alta relación resistencia-peso: la principal conífera estructural del Oeste.",
      description:
        "El Abeto Douglas ofrece una relación resistencia-peso sobresaliente y es la conífera estructural de referencia para vigas, maderas pesadas y entramados. Su grano recto y color cálido también lo hacen apto para carpintería vista y pisos.",
      color: "Marrón rojizo claro",
      uses: ["Madera estructural", "Vigas", "Carpintería", "Pisos"],
    },
    zh: {
      note: "强度重量比极高——美国西部首屈一指的结构软木。",
      description:
        "花旗松拥有卓越的强度重量比，是梁、重型木结构和框架的首选结构软木。其通直的纹理和温暖的色泽同样适用于外露细木工和地板。",
      color: "浅红棕色",
      uses: ["结构木材", "梁", "细木工", "地板"],
    },
  },
  "southern-yellow-pine": {
    es: {
      note: "Fuerte, resinoso y altamente tratable: la columna vertebral de la madera de construcción.",
      description:
        "El Pino Amarillo del Sur es el grupo de coníferas más resistente de Norteamérica, cultivado en el sureste de EE. UU. y apreciado mundialmente para la construcción. Denso y resinoso con alta resistencia a la flexión, acepta el tratamiento a presión mejor que casi cualquier otra conífera, siendo el estándar para terrazas, estructuras marinas y aplicaciones tratadas. El stock secado en horno, termotratado (KD-HT) y sellado de grado se envía listo para exportación para entramados, terrazas, pallets y usos industriales.",
      color: "Amarillento a rojizo",
      uses: ["Construcción", "Terrazas", "Pallets", "Madera tratada"],
    },
    zh: {
      note: "强度高、富含树脂、极易防腐处理——建筑用材的中坚力量。",
      description:
        "南方松是北美强度最高的软木类群，产于美国东南部，在全球建筑领域备受青睐。材质致密、富含树脂、抗弯强度高，其加压防腐处理性能几乎优于所有其他软木，是露台、海工结构和防腐应用的标准用材。窑干热处理（KD-HT）并加盖等级章的板材可直接出口，用于框架、露台、托盘和工业用途。",
      color: "黄色至微红色",
      uses: ["建筑", "露台地板", "托盘", "防腐木材"],
    },
  },
  "spruce-pine-fir-spf": {
    es: {
      note: "Ligera, clara y consistente: el principal grupo de madera de entramado de Canadá.",
      description:
        "SPF es un grupo de coníferas canadienses apreciado por su ligereza, color claro y calidades de entramado consistentes y sin nudos. Las opciones J-Grade y MSR sirven a los mercados más exigentes de entramado y embalaje en todo el mundo.",
      color: "Clara, pálida",
      uses: ["Entramados", "Construcción", "Embalaje"],
    },
    zh: {
      note: "轻质、色亮且品质稳定——加拿大顶级框架用材类群。",
      description:
        "SPF（云杉-松-冷杉）是加拿大软木类群，以轻质、色泽明亮和稳定少节的框架等级著称。J级和MSR机械应力分等材可满足全球高要求的框架和包装市场。",
      color: "明亮、浅色",
      uses: ["框架", "建筑", "包装"],
    },
  },
  "eastern-white-pine": {
    es: {
      note: "Blanda, estable y fácil de trabajar: un clásico para paneles y molduras.",
      description:
        "El Pino Blanco del Este es una conífera blanda, estable y fácil de trabajar, con textura fina y uniforme. Ha sido un básico de Nueva Inglaterra durante siglos, empleado en paneles, molduras, muebles y carpintería tradicional.",
      color: "Blanco cremoso a pajizo",
      uses: ["Paneles", "Molduras", "Muebles", "Carpintería"],
    },
    zh: {
      note: "质软、稳定、易加工——护墙板和线条的经典之选。",
      description:
        "东部白松是一种质软、稳定、易于加工的软木，纹理细腻均匀。数百年来一直是美国新英格兰地区的主打用材，广泛用于护墙板、线条、家具和传统细木工。",
      color: "奶白至麦秆色",
      uses: ["护墙板", "线条", "家具", "细木工"],
    },
  },
};

export const localizeSpecies = (species, lang) => {
  if (!species || lang === "en") return species;
  const tr = TR[species.slug]?.[lang];
  if (!tr) return species;
  return {
    ...species,
    note: tr.note || species.note,
    description: tr.description || species.description,
    uses: tr.uses || species.uses,
    properties: {
      ...species.properties,
      color: tr.color || species.properties.color,
      workability: WORKABILITY[lang]?.[species.properties.workability] || species.properties.workability,
    },
  };
};
